import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import UserProp from '../../../../commonComponents/propTypes/userProp';

export default function Comment({ comment }) {
  const avatar =
    comment.owner && comment.owner.image
      ? comment.owner.image.thumb
      : '/images/no_user.png';
  const username = comment.owner ? comment.owner.username : 'N/A';
  const date = moment.utc(comment.date).format('DD MMM, YY - HH:mm');

  return (
    <div className="comment-container">
      <div className="comment-avatar-container">
        <img src={avatar} alt="commenter avatar" />
      </div>
      <div className="comment-body">
        <div className="comment-header">{`${username}: ${date}`}</div>
        <div className="comment-text">{comment.message}</div>
      </div>
    </div>
  );
}

Comment.propTypes = {
  comment: PropTypes.shape({
    owner: PropTypes.shape(UserProp.propType).isRequired,
    message: PropTypes.string.isRequired,
    date: PropTypes.number.isRequired,
  }).isRequired,
};
